// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3616": "2bd20f1d2224","4972": "a139553a9c35","6495": "a9b28c737317",}[chunkId] + ".css"
}